import { analytics, EventNames, AnalyticsEvent } from "@lonelyplanet/lp-analytics";
import * as React from "react";
import Booking from "./booking";
var BookingActivity = function (_a) {
    var activityName = _a.activityName, activityType = _a.activityType, discountedPrice = _a.discountedPrice, price = _a.price, url = _a.url, provider = _a.provider, rating = _a.rating;
    return (React.createElement(Booking, null,
        price &&
            React.createElement(Booking.Price, { labelBefore: "from", originalPrice: discountedPrice ? price : null }, discountedPrice ? discountedPrice : price),
        React.createElement(AnalyticsEvent, { render: function (_a) {
                var track = _a.track;
                return (React.createElement(Booking.Button, { href: url, onClick: function () {
                        var _a;
                        track((_a = {},
                            _a[analytics.eventName] = EventNames.partnerClick,
                            _a[analytics.bookingDepartureDate] = undefined,
                            _a[analytics.bookingDestination] = activityName,
                            _a[analytics.bookingPartner] = provider,
                            _a[analytics.bookingReturnDate] = undefined,
                            _a[analytics.bookingType] = activityType,
                            _a));
                        track({
                            /**
                             * This is the legacy payload.
                             * Remove once OK to do so.
                             */
                            bookingProvider: provider,
                            event: "activity booking click",
                            "gtm.element": "Booking.Button",
                            "gtm.elementText": "Check prices and availability",
                        });
                    } }, "Check prices and availability"));
            } }),
        rating &&
            React.createElement(Booking.Rating, null, rating),
        React.createElement(Booking.Provider, { provider: provider })));
};
export default BookingActivity;



//////////////////
// WEBPACK FOOTER
// ./app/modules/pois/patterns/booking/bookingActivity.tsx
// module id = eF97
// module chunks = 2